<div class="page-container">
  <div class="card p-3 m-3">
  <div class="row px-3 mb-2">
    <div class="statistics mb-2 d-flex align-items-end gap-3">
      <a href="/statistics" class="statistics-link d-flex align-items-center gap-2">
        <h2 class="mb-0">
          <b style="color: black;">Statistiche Affidati</b>
        </h2>
        <i class="fas fa-reply return-icon"></i>
      </a>
    </div>


    <!-- FILTRI IN RIGA -->
    <form (ngSubmit)="fetchStatistics()">

      <div class="d-flex flex-wrap gap-3 mb-3">

        <div class="filter-item" style="min-width: 200px;" *ngIf="filteredClients.length > 1">
          <label class="form-label">Clienti</label>
          <div class="multi-select-wrapper">
            <ng-multiselect-dropdown
              *ngIf="filteredClients.length > 0 && dropdownSettingsClient"
              name="clients"
              [placeholder]="'Seleziona clienti'"
              [settings]="dropdownSettingsClient"
              [data]="filteredClients"
              [(ngModel)]="selectedClients"
              [ngModelOptions]="{standalone: true}"
              (onSelect)="onClientsChange()"
              (onDeSelect)="onClientsChange()"
              (onSelectAll)="selectAllClients()"
              (onDeSelectAll)="deselectAllClients()"
            >
            </ng-multiselect-dropdown>
          </div>
        </div>
        <div class="filter-item" style="min-width: 200px;" *ngIf="filteredBrands.length > 1">
          <label class="form-label">Marchi</label>
          <div class="multi-select-wrapper">
            <ng-multiselect-dropdown *ngIf="filteredBrands.length > 0 && dropdownSettingsBrand"
              name="brands"
              [placeholder]="'Seleziona marchi'"
              [settings]="dropdownSettingsBrand"
              [data]="filteredBrands"
              [(ngModel)]="selectedBrands"
              [ngModelOptions]="{standalone: true}"
              >
            </ng-multiselect-dropdown>
          </div>
        </div>

        <div class="filter-item" style="min-width: 150px;">
          <label class="form-label">Transit Point</label>
          <select class="form-select" [(ngModel)]="warehouseCode" name="warehouseCode">
            <option value="">Tutti i TP</option>
            <option *ngFor="let warehouse of filteredWarehouses" [value]="warehouse.warehouseCode">
              {{ warehouse.warehouseName }}
            </option>
          </select>
        </div>

        <div class="filter-item" style="min-width: 150px;">
          <label class="form-label">Dealer</label>
          <select class="form-select" [(ngModel)]="waybillDealerCode" name="waybillDealerCode">
            <option value="">Tutti i dealer</option>
            <option *ngFor="let dealer of filteredDealers" [value]="dealer.dealerCode">
              {{ dealer.dealerName }} - {{ dealer.dealerOperatingAddressCity }}
            </option>
          </select>
        </div>

        <div class="filter-item" style="min-width: 150px;">
          <label class="form-label">Regioni</label>
          <select class="form-select" [(ngModel)]="regionCode" name="regionCode">
            <option value="">Tutte le regioni</option>
            <option *ngFor="let region of filteredRegions" [value]="region.regionCode">
              {{ region.regionName }}
            </option>
          </select>
        </div>

        <div class="mb-2 d-flex">
          <div class="filter-item" style="min-width: 180px;">
            <label style="padding-left:30px;" class="form-label d-block">Data Inizio</label>
            <div class="d-flex align-items-center">
              <button class="date-nav-btn" type="button" (click)="decrementStartDate(); decrementEndDate()" title="Giorno precedente">
                <i class="fa fa-chevron-left"></i>
              </button>
              <input type="date" class="form-control" [(ngModel)]="waybillDateStart" name="waybillDateStart">

            </div>
          </div>

          <div class="filter-item" style="min-width: 180px;">
            <label class="form-label">Data Fine</label>
            <div class="d-flex align-items-center">
              <input type="date" class="form-control" [(ngModel)]="waybillDateEnd" name="waybillDateEnd">
              <button class="date-nav-btn" type="button" (click)="incrementStartDate(); incrementEndDate()" title="Giorno successivo">
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- BOTTONE FILTRA + RESET IN RIGA A DESTRA -->
      <div class="d-flex justify-content-end gap-2">
        <button class="btn btn-primary" type="submit">Applica Filtri</button>
        <button class="btn btn-light" type="button" (click)="resetFilters()">Reset</button>
      </div>

    </form>
  </div>
</div>


  <!-- LOADING -->
  <div *ngIf="loading" class="text-center mt-4">
    <div class="spinner-border text-primary" role="status"></div>
    <p>Caricamento dati...</p>
  </div>

  <!-- ERRORE -->
  <div *ngIf="error" class="alert alert-danger text-center">
    {{ error }}
  </div>

  <!-- WARNING -->
  <div *ngIf="warning" class="alert alert-warning p-3 m-3">
    <div class="d-flex align-items-center">
      <i class="fas fa-exclamation-triangle me-2"></i>
      <span>{{ warning }}</span>
    </div>
  </div>

  <!-- RISULTATI -->
  <div *ngIf="stats && !loading" class="row p-3 m-3">

    <!-- Card: Totale Bolle -->
    <div class="col-md-3 col-sm-6 "> 
      <div class="card shadow-sm h-100 border  bg-white p-3">
        <div class="card-body p-2">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="fs-4 text-dark">Totale bolle affidate</div>
            <div class="display-5 fw-bold text-dark mb-0">{{ stats.waybillsTotali }}</div>
          </div>

          <span class="text-dark"> Di cui:</span>

          <!-- Mini-info: DMDC -->
          <div class="bg-light border rounded px-3 py-2 mb-2 d-flex justify-content-between align-items-center">
            <span class="text-dark"> DMDC</span>
            <span class="fw-bold">{{ stats.waybillsDMDC }}</span>
          </div>

          <!-- Mini-info: BIG ORDERS -->
          <div class="bg-light border rounded px-3 py-2 d-flex justify-content-between align-items-center">
            <span class="text-dark"> Big Orders</span>
            <span class="fw-bold">{{ stats.waybillsBigOrders }}</span>
          </div>

        </div>
      </div>
    </div>

    <!-- Card: Totale Colli -->
    <!-- Card: Totale Colli -->
    <div class="col-md-3 col-sm-6">
      <div class="card shadow-sm h-100 border bg-white p-3">
        <div class="card-body p-2">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="fs-4 text-dark">Totale colli affidati</div>
            <div class="display-5 fw-bold text-dark mb-0">{{ stats.parcelsTotali }}</div>
          </div>

          <span class="text-dark"> Di cui:</span>

          <!-- Mini-info: DMDC -->
          <div class="bg-light border rounded px-3 py-2 mb-2 d-flex justify-content-between align-items-center">
            <span class="text-dark"> DMDC</span>
            <span class="fw-bold">{{ stats.parcelsDMDC }}</span>
          </div>

          <!-- Mini-info: BIG ORDERS -->
          <div class="bg-light border rounded px-3 py-2 mb-2">
            <div class="d-flex justify-content-between align-items-center">
              <span class="text-dark">Big Orders</span>
              <span class="fw-bold">{{ stats.parcelsBigOrders }}</span>
            </div>
            
            <div class="ms-3 mt-1">
              <span class="text-dark d-block">Di cui:</span>
              <div class="d-flex justify-content-between">
                <span class="text-dark">- inviati a PTV</span>
                <span class="fw-bold">{{ stats.parcelsBigOrdersPTV }}</span>
              </div>
            </div>
          </div>

          <!-- Mini-info: MANCANTI
          <div class="bg-light border rounded px-3 py-2 mb-2 d-flex justify-content-between align-items-center">
            <span class="text-dark"> Mancanti e/o lasciati a terra</span>
            <span class="fw-bold">{{ stats.parcelsMancanti }}</span>
          </div> -->

          <!-- Totale da confrontare -->
          <div class="bg-white border border-bright-green rounded px-3 py-2 mt-3">
            <div class="d-flex justify-content-between align-items-center">
              <span class="text-bright-green fw-semibold fs-5">Totale da confrontare con PTV</span>
              <span class="fw-bold text-bright-green fs-5">
                {{
                  stats.parcelsTotali -
                  stats.parcelsBigOrders +
                  stats.parcelsBigOrdersPTV
                }}
              </span>
            </div>

            <!-- <div *ngIf="dateBefore26" class="mt-2">
              <small class="fst-italic text-muted d-block">
                <i class="fas fa-exclamation-triangle me-1" style="color: orange;"></i>
                Da sommare i colli mancanti e/o lasciati a terra
              </small>
            </div> -->
          </div>

        </div>
      </div>
    </div>


  </div>

</div>